<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptertitle"><a id="p6"></a> Dena Sheets's Fiery Breakfast Burritos</h1>
<p class="left">Here is another pack 'em in your saddlebag and ride breakfast treat. After you work up an appetite riding in the morning air, you can enjoy these at a scenic rest area. This recipe is from Dena Sheets, a Harley lady from Lead, South Dakota, who tells us, "These burritos are great to fix in the morning, go for a putt, and chow down in about an hour. Wrap them in tin foil, put them in the saddlebags, and eat in about an hour or two."</p>
<p class="timebreak"> <br/></p>
<table>
<tr>
<td align="left" valign="top"><b>2</b></td>
<td align="left" valign="top"><b>pounds pork roast, cooked in the slow cooker the night before (see Note)</b></td>
</tr>
<tr>
<td align="left" valign="top"><b>12</b></td>
<td align="left" valign="top"><b>10-inch flour tortillas</b></td>
</tr>
<tr>
<td align="left" valign="top"><b>12</b></td>
<td align="left" valign="top"><b>large eggs, scrambled</b></td>
</tr>
<tr>
<td align="left" valign="top"><b>2</b></td>
<td align="left" valign="top"><b>4-ounce cans diced green chiles, drained</b></td>
</tr>
<tr>
<td align="left" valign="top"><b>2</b></td>
<td align="left" valign="top"><b>4-ounce cans diced jalapeños, drained</b></td>
</tr>
<tr>
<td align="left" valign="top"><b>12</b></td>
<td align="left" valign="top"><b>ounces cheddar cheese, shredded</b></td>
</tr>
<tr>
<td align="left"></td>
<td align="left" valign="top"><b>Salsa</b></td>
</tr>
</table>
<ol>
<li>Heat the shredded pork in a small amount of water till very hot. Heat the tortillas one at a time in the microwave according to the package directions.</li>
<li>Place some shredded pork, eggs, chiles, jalapeños, cheese, and salsa on each tortilla. Fold up and wrap in tin foil to keep warm or serve immediately.</li>
</ol>
<p class="timebreak"> <br/></p>
<p class="right"><b><span style="font-size: smaller">MAKES</span> 12 <span style="font-size: smaller">BURRITOS</span></b></p>
<p class="timebreak"> <br/></p>
<blockquote><p class="left"><b><span style="font-size: smaller">NOTE</span></b> Cook the pork with 2 teaspoons ground cumin, 2 tablespoons chopped garlic, 2 teaspoons chili powder, and salt and black pepper to taste. Once it's fork tender, shred the pork and refrigerate till morning.</p></blockquote>
<p class="follow"></p>
<p class="follow"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c004.vue?13439717